import React from "react";
import { Link } from "react-router-dom";
import "../styles/landingpage/landingPage.css";
import { clientMessage } from "../constants/landingPageConstsnt";
import ClientMessage from "./ClientMessage";

const LandingPageBody = () => {
  return (
    <div>
      <div className="landingPageBody">
        <div className="landing-page-text">
          <div className="landing-page-introducing">
            <div>
              <h3 className="landing-page-introducing-text">Introducing </h3>
              <Link to="/halliv" className="halliv-link-introducing">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/hallIv-transparent-logo.png"
                  }
                  alt="HallIv"
                  className="landing-page-halliV-img img-fluid"
                />
              </Link>
            </div>
          </div>
          <h3>
            A platform that empowers studios, distributors, filmmakers,
            independent artists and creators to reach and connect with their
            target audience online.
          </h3>
          <div className="create-account">
            <button type="button" class="button-89" id="get-started-btn">
              <Link
                to="https://creators.halliv.com/registration"
                className="link"
              >
                {" "}
                Get started for free
              </Link>
            </button>
          </div>
          <span className="account-sign-in">
            Already a HallIV user?
            <Link
              to="https://creators.halliv.com/login"
              className="link"
              id="sign-in-link"
            >
              {" "}
              Sign In
            </Link>
          </span>
        </div>
      </div>
      <div className="landing-content">
        <div className="different-devices">
          <img
            src={process.env.PUBLIC_URL + "/images/multi-device.gif"}
            alt="Logo"
            className="img-fluid"
          />
        </div>
        <div className="landing-conents-description">
          <div className="landing-content-benifit">
            <h5>Get Free Access to the Hall IV Publishing Hub</h5>
            <p>
              Access a transparent platform to submit, manage and strategically
              promote your content for free.
            </p>
          </div>
          <div className="landing-content-benifit">
            <h5>Reach your Audience, Wherever, Whenever</h5>
            <p>
              Smart Tvs, Firesticks, PCs, Laptops, Tablets or Smartphones -
              Connect with your audience on their preferred devices, no matter
              where they are.
            </p>
          </div>
          <div className="landing-content-benifit">
            <h5>Optimise and Monetise your Art</h5>
            <p>
              Get strategic insights with detailed metrics like streaming time,
              total time of streaming, number of content consumers, revenues and
              payment patterns, to help you promote your work among your
              audience in the best way possible.
            </p>
          </div>
        </div>
      </div>
      <hr />
      <div className="clientsMessage">
        {/* {
        clientMessage.map((client, index) => <ClientMessage key={index} props = { client } />)
      } */}
      </div>
    </div>
  );
};

export default LandingPageBody;
